/* Odds Comfort: wishlist. Stored on the device (localStorage), shareable by link, synced across tabs.
   Any element with data-wish="<product handle>" toggles; [data-wish-count] shows the total. */
(function () {
  'use strict';
  var Odds = window.Odds; if (!Odds) return;
  var KEY = 'odds:wish:v1';
  var list = Odds.store.get(KEY, []);
  if (!Array.isArray(list)) list = [];

  function save() { Odds.store.set(KEY, list); }
  function idx(h) { for (var i = 0; i < list.length; i++) if (list[i].h === h) return i; return -1; }

  var W = (Odds.wishlist = {
    handles: function () { return list.slice().sort(function (a, b) { return b.t - a.t; }).map(function (x) { return x.h; }); },
    count: function () { return list.length; },
    has: function (h) { return idx(h) > -1; },
    add: function (h, silent) {
      if (idx(h) > -1) return;
      list.push({ h: h, t: Date.now() }); save();
      if (Odds.brain) Odds.brain.track('wish', { h: h });
      W.sync(); Odds.emit('wishlist:change', { handle: h, added: true });
      if (!silent) Odds.toast(Odds.t('wish_saved'), Odds.t('wish_view'), function () { location.href = Odds.cfg.routes.wishlist; });
    },
    remove: function (h, silent) {
      var i = idx(h); if (i < 0) return;
      var rec = list.splice(i, 1)[0]; save();
      W.sync(); Odds.emit('wishlist:change', { handle: h, added: false });
      if (!silent) Odds.toast(Odds.t('wish_removed'), Odds.t('undo'), function () { list.push(rec); save(); W.sync(); Odds.emit('wishlist:change', { handle: h, added: true }); });
    },
    toggle: function (h) { if (W.has(h)) W.remove(h); else W.add(h); },
    clear: function () { list = []; save(); W.sync(); Odds.emit('wishlist:change', {}); },
    shareUrl: function () { return location.origin + Odds.cfg.routes.wishlist + '?items=' + encodeURIComponent(W.handles().join(',')); },
    sync: function () {
      Odds.$$('[data-wish]').forEach(function (b) {
        var on = W.has(b.getAttribute('data-wish'));
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
        var lbl = on ? Odds.t('wish_unsave') : Odds.t('wish_save');
        if (b.classList.contains('heart') || b.classList.contains('icon-btn')) b.setAttribute('aria-label', lbl);
        var txt = b.querySelector('[data-wish-text]'); if (txt) txt.textContent = on ? Odds.t('wish_saved_label') : Odds.t('wish_save');
      });
      Odds.$$('[data-wish-count]').forEach(function (el) { el.hidden = !list.length; el.textContent = list.length; });
      Odds.$$('[data-wish-count-text]').forEach(function (el) { el.textContent = list.length; });
    }
  });

  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-wish]');
    if (!b) return;
    e.preventDefault(); e.stopPropagation();
    var h = b.getAttribute('data-wish');
    var was = W.has(h);
    W.toggle(h);
    if (!was) { b.classList.remove('beat'); void b.offsetWidth; b.classList.add('beat'); }
  });
  window.addEventListener('storage', function (e) {
    if (e.key === KEY) { list = Odds.store.get(KEY, []) || []; W.sync(); Odds.emit('wishlist:change', {}); }
  });
  // re-sync after any DOM update that adds cards (quick view, filters, rails)
  Odds.on('dom:updated', W.sync);
  W.sync();
  document.addEventListener('DOMContentLoaded', W.sync);
})();
